

export default class {
   // Opera 8.0+
   static isOpera() {
      var opr = opr || null;
      var ret = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
      return ret;
   }

   // Firefox 1.0+
   static isFirefox() {
      var ret = typeof InstallTrigger !== 'undefined';
      return ret;
   }

   // Safari 3.0+ "[object HTMLElementConstructor]"
   static isSafari() {
      var safari = safari || null;
      var ret = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || safari.pushNotification);
      return ret;
   }

   //Internet Explorer 6-11
   static isIE() {
      var ret = /*@cc_on!@*/false || !!document.documentMode;
      return ret;
   }

   // Edge 20+
   static isEdge() {
      var ret = !this.isIE() && !!window.StyleMedia;
      return ret;
   }

   // Chrome 1+
   static isChrome() {
      var ret = !!window.chrome && !!window.chrome.webstore;
      return ret;
   }

   // Blink engine detection
   static isBlink() {
      var ret = (this.isChrome() || this.isOpera()) && !!window.CSS;
      return ret;
   }

   static currentBrowser() {
      if (this.isOpera()) {
         return 'Opera';
      } else if (this.isFirefox()) {
         return 'Firefox';
      } else if (this.isSafari()) {
         return 'Safari';
      } else if (this.isIE()) {
         return 'IE';
      } else if (this.isEdge()) {
         return 'Edge';
      } else if (this.isChrome()) {
         return 'Chrome';
      } else if (this.isBlink()) {
         return 'Blink';
      } else {
         return 'Unsupported';
      }
   }
}


// WEBPACK FOOTER //
// ./src/utils/browser.js